var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('my-tc-tickets')],1)]),_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-xl-12"},[_c('my-tc-incident-reports')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }